import { Col, Row } from 'antd'
import { Card, Icon, LoadingSpinner, Modal, Toggle, Tooltip } from 'pepsico-ds'
import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { trackModalView, getModalAttributes } from '../../utils/fullstory-utils';
import { urlConstants } from '../../constants/urlConstants';
import CustomButtons from '../Cards/CustomButtons';
import { localStoreKeys } from '../../constants/localStoreKeys';
import SingleSelectDropdown from '../Dropdown/SingleSelectDropdown'
import { formatNumberWithCommas, splitValueWithUnit, returnHyphenIfNull, splitNumericValue } from '../../utils/utils';
import ModalFilters from './ModalFilters';
import InfoIcon from '../Icons/InfoIcon';
import NoData from '../NoData/NoData';
import AribaThreeColoredBarChart from '../Charts/AribaChart/AribaThreeColoredBarChart';
import AribaPieChart from '../Charts/AribaChart/AribaPieChart';
import AribaCoverageBarChart from '../Charts/AribaChart/AribaCoverageBarChart';
import LegendList from '../Charts/Legend/LegendList';
import SpendStackedBarChart from '../Charts/SpendAnalyticsChart/SpendStackedBarChart';
import AribaLineThreeColoredBarChart from '../Charts/AribaChart/AribaLineThreeColoredBarChart';
import AribaBucketTreemapChart from '../Charts/AribaChart/AribaBucketTreemapChart';
import CommonTable from '../Table/CommonTable';
import DropdownWithIcons from './DropdownWithIcons';
import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';
import AribaHeaderTable from '../Table/AribaHeaderTable';
const MODAL_TITLE = 'Sourcing(Launch RFx, Negotiation)';

const cellDataFunction = (ctx) => {
    const colId = ctx.column.id
    if(ctx.row.original[colId]==null) {
        return <div>-</div>
    }
    if (colId === "annualizedspend") {
        return (
            <div>{formatNumberWithCommas(ctx.row.original[colId])}</div>
        )
    }
    if (colId === "projectName") {
        return (
            <div style={{ textAlign: 'left', paddingLeft: 15 }}>{ctx.row.original[colId]}</div>
        );
    }
    // if (colId === "projectId") {
    //     return (
    //         <div style={{ textAlign: 'left', paddingLeft: 15 }}>{ctx.row.original[colId]}</div>
    //     );
    // }
    const percentage = ctx.row.original[colId]
    return (
        <div>{percentage}</div>
    )
    // return (
    //     <div style={{ textAlign: 'left', paddingLeft: 15 }}>{percentage}</div>
    // )
}
const aribaColumns = [
    { columnKey: 'a', header: '' },
    { columnKey: 'projectID', header: 'Project ID', columnAlignment:'center', size: 100, minSize: 100, maxSize: 100 },
    { columnKey: 'projectName', header: 'Project Name', columnAlignment:'center', cellData: cellDataFunction, size: 500, minSize: 500, maxSize: 500 },
    { columnKey: 'sectorBu', header: 'Sector-BU', columnAlignment:'center', size: 100, minSize: 100, maxSize: 100 },
    { columnKey: 'l0Category', header: 'Category L0', columnAlignment:'center', size: 100, minSize: 100, maxSize: 100 },
    { columnKey: 'l1Category', header: 'Category L1', columnAlignment:'center', size: 100, minSize: 100, maxSize: 100 },
    { columnKey: 'l2Category', header: 'Category L2', columnAlignment:'center', size: 100, minSize: 100, maxSize: 100 },
    { columnKey: 'projectStatus', header: 'Project Status', columnAlignment:'center', size: 100, minSize: 100, maxSize: 100 },
    { columnKey: 'annualizedspend', header: 'Annualized Est. E-Sourcing Spend (Mn, USD)', cellData: cellDataFunction, columnAlignment:'center', size: 100, minSize: 100, maxSize: 100 },
    { columnKey: 'currency', header: 'Currency', columnAlignment:'center', size: 100, minSize: 100, maxSize: 100 },
    { columnKey: 'yearMonth', header: 'Year-Month', columnAlignment:'center', size: 100, minSize: 100, maxSize: 100 },
    { columnKey: 'suppliersInvited', header: 'Suppliers Invited', columnAlignment:'center', size: 100, minSize: 100, maxSize: 100 },
    
];

const aribaColumnsToInclude = [
    'SECTOR',
    'BU',
    'CATEGORY L0',
    'CATEGORY L1',
    'CATEGORY L2',
    'PROJECT ID',
    'PROJECT NAME',
    'PROJECT OWNER',
    'EVENT OWNER',
    'PROJECT STATUS',
    'EVENT ID',
    'EVENT TYPE',
    'EVENT STATUS',
    'BIDDING START DATE',
    'BIDDING END DATE',
    'CURRENCY',
    'SUPPLIERS INVITED',
    'ANNUALIZAED ESTIMATED. E-SOURCING SPEND (MN, USD)',
]; 
const aribaColumnMapping = {
        "sector": "SECTOR",
        "bu": "BU",
        "l0Category": "CATEGORY L0",
        "l1Category": "CATEGORY L1",
        "l2Category": "CATEGORY L2",
        "projectID": "PROJECT ID",
        "projectName": "PROJECT NAME",
        "projectOwner": "PROJECT OWNER",
        "eventOwner": "EVENT OWNER",
        "projectStatus": "PROJECT STATUS",
        "eventID": "EVENT ID",
        "eventType": "EVENT TYPE",
        "eventStatus": "EVENT STATUS",
        "biddingStartDate": "BIDDING START DATE",
        "biddingEndDate": "BIDDING END DATE",
        "currency": "CURRENCY",
        "suppliersInvited": "SUPPLIERS INVITED",
        "annualizedspend": "ANNUALIZAED ESTIMATED. E-SOURCING SPEND (MN, USD)",
};

function AribaModal({ openModal, setOpenModal, userData, selectedYear, capability, userDataLandingPage, landingPageFilters, appName }) {

    const pieChartBreakdownValue = [
        { displayText: 'Sector', id: 1, value: 'sector' },
        { displayText: 'Event Type', id: 2, value: 'eventType' },
        { displayText: 'Category L0', id: 3, value: 'categoryL0' },
        { displayText: 'Category L1', id: 4, value: 'categoryL1' }
    ]

    useEffect(() => {
        if (openModal) {
            try {
                trackModalView(`${MODAL_TITLE} ${capability}`, 'view');
            } catch (error) {
                // Silent fail for tracking errors to not disrupt user experience
            }
        }
    }, [openModal, capability]);

    const handleClose = () => {
        try {
            trackModalView(`${MODAL_TITLE} ${capability}`, 'close');
        } catch (error) {
            // Silent fail for tracking errors
        }
        setDataLoadActionType("");
        setOpenModal(false);
    };
   
    const [aribaData, setAribaData] = useState({})
    const [loader, setLoader] = useState(true)
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
    const isLoading = useSelector((state) => state?.loader?.isLoading);
    const [dataLoadActionType, setDataLoadActionType] = useState("");
    const [spendBreakdownVal, setSpendBreakdownVal] = useState([pieChartBreakdownValue[0]])
    const [pieChartToggle, setPieChartToggle] = useState(false)
    const [stackedBarChartToggle, setStackedBarChartToggle] = useState(false);
    const [pieChartData, setPieChartData] = useState([])
    const [pieChartLegends, setPieChartLegends] = useState([])
    const [pieChartColors, setPieChartColors] = useState([])
    
    const getAribaDataFromFilters = (value) => {
        let appList = [];
        if(value?.data?.type==="SUCCESS_ARIBA_DETAIL_VIEW_ACTION") {
            
            setAribaData(value.data)
            setLoader(value.loader);
            setDataLoadActionType(value?.data?.type)
            appList = value.data?.apps;
        }
        setStackedBarChartToggle(false)
        setPieChartToggle(false)
        setSpendBreakdownVal([pieChartBreakdownValue[0]])

        if (value.modalName == "Ariba" && appList && appList.length > 0) {
            const tempbuttonGroupItems = [
                // Using ?? [] ensures the spread operator always receives an array
                ...(appList
                    ?.filter(item => item.isActive)
                    .map(item => ({
                        label: item.app,
                        onClick: () => window.open(item.url, "_blank"),
                    })) ?? []) 
            ];
            setButtonGroupItems(tempbuttonGroupItems)
        }
    }

    const numberOfProjects = aribaData?.aribaSourcingHeaderResponse?.totalProject;
    const activeProjects = aribaData?.aribaSourcingHeaderResponse?.activeProject;
    const completedProjects = aribaData?.aribaSourcingHeaderResponse?.completedProject;
    const spendCoverage = aribaData?.aribaSourcingHeaderResponse?.spendCoverage;
    const sourcingSpend = aribaData?.aribaSourcingHeaderResponse?.eSourcingSpend;
    const sourcingSpendtValue = splitValueWithUnit(sourcingSpend)?.['numericValue']
    const sourcingSpendUnit = splitValueWithUnit(sourcingSpend)?.['unit']
    const numberOfEvents = aribaData?.aribaSourcingHeaderResponse?.totalEvents;
    const pendingEvents = aribaData?.aribaSourcingHeaderResponse?.pendingSelectionEvents;
    const completedEvents = aribaData?.aribaSourcingHeaderResponse?.completedEvents;

    const spendCoverageData = aribaData?.spendCoverage
    const isEDFIntegrated = aribaData?.edfintegrated;


    const categoryColorMapping = aribaData?.categoryColorMapping
    // const spendAtSectorAndCategoryL1Data = aribaData?.spendAtSectorAndCategoryL1
    const projectCountAtSectorAndCategoryL1Data = aribaData?.projectCountAtSectorAndCategoryL1
    const l1CatgoryColorsData = projectCountAtSectorAndCategoryL1Data?.flatMap(item =>
        categoryColorMapping?.map(style => ({
          category: item.category,
          name: style.name,
          color: style.color
        }))
      );
    const tableData = aribaData?.aribaSourcingTabularData;
    
    // const aggregatedSpendBySectorEventData = aribaData?.aggregatedSpendBySectorEvent
    const aggregatedSpendBySectorEventData = aribaData?.aggregatedCountBySectorEvent
    const spendAndProjectCountByMonthAndEventTypeData = aribaData?.spendAndProjectCountByMonthAndEventType
    const spendBucketAndProjectCountData = aribaData?.spendBucketAndProjectCount
    const pieChartResponseData = aribaData?.pieChartResponse

    const aribaModalRef = useRef(); 
    const aribaEsourcingSpendCoverageChartRef = useRef();
    const annualizedEstESourcingSpendSplitChartRef = useRef();
    const spendByEventTypevsProjectsChartRef = useRef();
    const spendBySectorEvenTypeStatusChartRef = useRef();
    const SpendbySectorandCategoryL1ChartRef = useRef();
    const annualizedSpendRangesChartRef = useRef();
    
    // const projectCountAtSectorAndCategoryL1Data = aribaData?.projectCountAtSectorAndCategoryL1  
    
    function transformObjectToArrayFormat(obj) {
        const resultArray = [];
        for (const category in obj) {
            if (obj.hasOwnProperty(category)) {
                const newEntry = { category };
                const states = obj[category];
    
                for (const state in states) {
                    if (states.hasOwnProperty(state)) {
                        const stateName = state.includes('Pending') ? 'Pending' : state; // Use only 'Pending' or 'Completed'
                        newEntry[stateName] = {};
    
                        for (const key in states[state]) {
                            if (states[state].hasOwnProperty(key)) {
                                newEntry[stateName][key] = parseFloat(states[state][key]); // Convert to number
                            }
                        }
                    }
                }
    
                resultArray.push(newEntry);
            }
        }
        return resultArray;
    }

    const convertedAggregatedSpendBySectorEventData = transformObjectToArrayFormat(aggregatedSpendBySectorEventData);
   
    useEffect(() => {
        const key = spendBreakdownVal?.[0]?.value;
        const type = pieChartToggle ? 'eventCount' : 'projectCount';
        setPieChartData(pieChartResponseData?.[key]?.[type]);
        const updatedPieChartLegends = pieChartResponseData?.[key]?.colorDetails.map(item => {
            return {
                ...item,
                color: item.value,
                // value: undefined // this removes the value property
            };
        });
        setPieChartLegends(updatedPieChartLegends)
      }, [pieChartResponseData, pieChartToggle, spendBreakdownVal]);

      useEffect(()=>{
        const pieColors = pieChartLegends?.map(item => item.color)
        setPieChartColors(pieColors)
      }, [pieChartLegends])

    const threeColoredBarChartLegends= [
        {
            "name": "RFI",
            "color": "#E66A00"
        },
        {
            "name": "RFP",
            "color": "#800080"
        },
        {
            "name": "Auction",
            "color": "#47554F"
        }
    ]

    const lineThreeColoredBarChartLegends= [
        {
            "name": "RFI",
            "color": "#E66A00"
        },
        {
            "name": "RFP",
            "color": "#800080"
        },
        {
            "name": "Auction",
            "color": "#47554F"
        },
        // {
        //     "name": "Projects",
        //     "color": "#FF891C"
        // }
    ]

    const treeMapLegends = [
        {
            "name": "More than $50 Mn", //',, , , , , '#4F357A', '#818181'
            "color": '#6A3452'
        },
        {
            "name": "$10 Mn to $50 Mn",
            "color": '#B05788'
        },
        {
            "name": "$5 Mn to $10 Mn",
            "color": '#8458CC'
        },
        {
            "name": "$1 Mn to $5 Mn",
            "color": '#FF891C'
        },
        {
            "name": "$0.5 Mn to $1 Mn",
            "color": '#33ABDA'
        },
        {
            "name": "Less than $0.5 Mn",
            "color": '#0078A7'
        }
    ]
    
    const onDropdownChange = (val) => {
        if(val && val.length>0) {
            setSpendBreakdownVal(val)
        }
    }



    const { showToast } = useToast();


    
    const checkPDFDownloaded = () => {}
    
    return (
        <Modal
            // onClick={(e) => e.stopPropagation()}
            closeOnOutsideClick={false}
            // onClick={handleClick}
            onCloseModal={handleClose}
            primaryButtonProps={{
                onClick: handleClose,
                size: "medium",
                text: "Close",
                variant: "primary",
            }}
            showPrimaryButton={true}
            showLink={false}
            showSecondaryButton={false}
            showTertiaryButton={false}
            showAuxiliaryButton={false}
            showSlot={true}
            showModal={openModal}
            hideCloseButton={false}
            type="XL"
            {...getModalAttributes(`${MODAL_TITLE} ${capability}`)}
        >
            <div ref={aribaModalRef}>
                <div className="modal-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span>
                    {userData?.FirstName}, number of projects through SAP Ariba for your category are <b>{numberOfProjects ? formatNumberWithCommas(numberOfProjects) : 0}</b>
                    {
                        isEDFIntegrated &&
                        <Tooltip direction="bottom" text={staticNotes.EDF_NOTE}>
                            <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible", marginBottom: "7px" }} />
                        </Tooltip>
                    }
                </span>        
                    {
                        isLoading ? (
                            <></>
                        ) :                    
                        <>
                            <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <CustomButtons isModal={true} appList={aribaData?.apps} />
                                    {/* <button onClick={() => handleDomToImgDownloadPdf(compassModalRef, "Compass_Modal")}>PDF</button> */}
                                    <span style={{float: 'right', position: 'relative', right: '2rem', bottom: '0.6rem'}}>
                                        <DropdownWithIcons modalRef={aribaModalRef} kpiName={"Ariba_Modal"} isModal={true} checkPDFDownloaded={checkPDFDownloaded}/>
                                    </span>
                            </span>
                        </>
                    }
                </div>

            
            {(aribaData?.lastUpdate) && (<div className="modal-update-frequesncy">Data As On: {returnHyphenIfNull(aribaData?.lastUpdate)} | Refresh Frequency: {returnHyphenIfNull(aribaData?.refreshFrequency)}</div>)}
            <ModalFilters modalName={"Ariba"} selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} onParentCallback={getAribaDataFromFilters} landingPageFilters={landingPageFilters} setLoader={setLoader} appName={appName} />
            <br />
            {
                (loader || isLoading) ?
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                        <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                    </div>
                    :
                    <>
                        <div style={{ marginTop: 10, marginBottom: 10, display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
                                <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <Card style={{ height: '100%',display:'flex' }}>
                                            <div className='header-kpi-wrapper' style={{justifyContent: 'space-between', width: '100%'}}>
                                            {/* {
                                                spendCoverage !== undefined || spendCoverage !== null ?
                                                    <>
                                                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                                                <div style={{ display: 'flex',justifyContent:"space-between" }}>
                                                                    <div>
                                                                        <div className="spend-modal-alphanumeric-value-small">
                                                                            <div className='spend-modal-numeric-value-small'>{numberOfProjects ? formatNumberWithCommas(numberOfProjects) : 0}</div>
                                                                        </div>
                                                                        <div className='spend-modal-manage-spend'>Projects</div>
                                                                    </div>
                                                                    <div>
                                                                        <div className="spend-modal-alphanumeric-value-small">
                                                                            <div className='spend-modal-numeric-value-small' style={{ fontSize: 24 }}>{activeProjects ? formatNumberWithCommas(activeProjects) : 0}</div>
                                                                        </div>
                                                                        <div className='spend-modal-manage-spend'>Active</div>
                                                                    </div>
                                                                    <InfoIcon style={{marginTop:"3px"}} text="% of Annualized Est. E-Sourcing Spend through e-sourcing (RFI/RFP/Auction) out of Total Spend" />
                                                                </div>
                                                        </Col>       
                                                    </>
                                                    : ''
                                            } */}
                                            {
                                                numberOfProjects !== undefined && numberOfProjects !== null ?
                                                    <>
                                                        {/* <div className="compass-modal-divider-verticle" /> */}
                                                        <Col xs={24} sm={24} md={9} lg={9} xl={9} style={{position: 'relative'}}>
                                                            <div style={{ display: 'flex',justifyContent:"space-between", marginTop: '3rem' }}>
                                                                <div>
                                                                    <div className="spend-modal-alphanumeric-value-small">
                                                                        <div className='spend-modal-numeric-value-small' style={{fontWeight: '700 !important'}}>{numberOfProjects ? formatNumberWithCommas(numberOfProjects) : 0}</div>
                                                                        <span style={{position: 'relative', bottom: '1rem'}}>
                                                                            <InfoIcon text="Project Status not part of data: Cancelled and On Hold"  />
                                                                        </span>
                                                                    </div>
                                                                    
                                                                    <div className='spend-modal-manage-spend'>Total Projects</div>
                                                                </div>
                                                                <div>
                                                                    <div className="spend-modal-alphanumeric-value-small">
                                                                        {/* <div className='spend-modal-numeric-value-small' style={{ fontSize: 24, color: '#FF891C' }}>{activeProjects ? formatNumberWithCommas(activeProjects) : 0}</div> */}
                                                                        <div className='ariba-header-value-text'>{activeProjects ? formatNumberWithCommas(activeProjects) : 0}</div>
                                                                    </div>
                                                                    <div className='spend-modal-manage-spend'>Active<br/>Projects</div>                     
                                                                </div>
                                                                <div style={{position: 'relative'}}>
                                                                    <div className="spend-modal-alphanumeric-value-small">
                                                                        {/* <div className='spend-modal-numeric-value-small' style={{ fontSize: 24, color: '#006A42' }}>{completedProjects ? formatNumberWithCommas(completedProjects) : 0}</div> */}
                                                                        <div className='ariba-header-value-text' >{completedProjects ? formatNumberWithCommas(completedProjects) : 0}</div>
                                                                    </div>
                                                                    <div className='spend-modal-manage-spend'>Completed<br/>Projects</div>
                                                                    
                                                                </div>

                                                                
                                                            </div>
                                                        </Col>
                                                    </> : ''
                                            }
                                            {/* {
                                                sourcingSpend !== undefined || sourcingSpend !== null ?
                                                    <>
                                                        <div className="archlet-modal-divider-verticle" />
                                                        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                                            <div>
                                                                <div className= "spend-modal-alphanumeric-value">
                                                                    <div className='spend-modal-numeric-value'>{formatNumberWithCommas(sourcingSpendtValue) || 0}</div>
                                                                    <div className="spend-modal-alpha-value" style={{ display: "flex" }}>{sourcingSpendUnit} </div>
                                                                </div>
                                                                <div className='archlet-modal-header-kpi-description' style={{ display: "flex" }}>Annualized Est. E-Sourcing Spend</div>
                                                            </div>
                                                        </Col>
                                                    </>
                                                    : ''
                                            } */}
                                            
                                            {
                                                numberOfEvents !== undefined && numberOfEvents !== null ?
                                                    <>
                                                        <div className="compass-modal-divider-verticle" />
                                                        <Col xs={24} sm={24} md={13} lg={13} xl={13} >
                                                            {/* <div style={{ display: 'flex',justifyContent:"space-between" }}> */}
                                                            <div style={{ display: 'flex' }}>
                                                                <div style={{width: '20%', marginTop: '3rem'}}>
                                                                    <div className="spend-modal-alphanumeric-value-small">
                                                                        <div className='spend-modal-numeric-value-small' style={{fontWeight: '700 !important'}}>{numberOfEvents ? formatNumberWithCommas(numberOfEvents) : 0}</div>
                                                                        <span style={{position: 'relative', bottom: '1rem'}}>
                                                                            <InfoIcon text="Event Status not part of data: Cancelled, Open, Paused, Prebid Review, Preview" />
                                                                        </span>
                                                                    </div>
                                                                    <div className='spend-modal-manage-spend'>Total Events</div>
                                                                </div>
                                                                {/* <div>
                                                                    <div className='spend-modal-manage-spend'># Pending Selection</div>
                                                                    <div className="spend-modal-alphanumeric-value-small">
                                                                        
                                                                        <div className="kpi-card-percentage-value" style={{maxHeight:"40px", fontWeight:"normal"}}>{pendingEvents ? formatNumberWithCommas(pendingEvents) : 0}</div>
                                                                    </div> 
                                                                </div>
                                                                <div>
                                                                    <div className='spend-modal-manage-spend'># Completed</div>
                                                                    <div className="spend-modal-alphanumeric-value-small">
                                                                        
                                                                        <div className="kpi-card-percentage-value" style={{maxHeight:"40px", fontWeight:"normal"}}>{completedEvents ? formatNumberWithCommas(completedEvents) : 0}</div>
                                                                    </div>
                                                                </div> */}

                                                                <div style={{margin: '0 25px', width: '75%'}}>
                                                                    <AribaHeaderTable response={aribaData?.aribaSourcingHeaderResponse}/>
                                                                </div>

                                                                
                                                                
                                                            </div>
                                                        </Col>
                                                    </> : ''
                                            }
                                            </div>
                                        </Card>
                                    </Col> 
                                </Row>
                            </div>
                                <div>
                                    <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                        
                                        {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <div ref={aribaEsourcingSpendCoverageChartRef}>
                                            <Card style={{ height: '100%' }} className="archlet-chart-card">
                                            
                                                <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>                                       
                                                    Ariba E-sourcing Spend Coverage
                                                    <InfoIcon  
                                                        style={{position: 'relative', left: '0.5rem'}}
                                                        text={`Ariba E-sourcing Spend
                                                        Coverage is only available for
                                                        completed years.`} 
                                                    />
                                                    <span style={{float: 'right'}}>
                                                        <DropdownWithIcons checkPDFDownloaded={checkPDFDownloaded} modalRef={aribaEsourcingSpendCoverageChartRef} kpiName={"Ariba E-sourcing Spend Coverage"}/>
                                                    </span>
                                                </div>
                                                <div style={{marginTop: '5rem'}}>
                                                {
                                                    spendCoverageData && spendCoverageData?.length > 0 ?
                                                    <>
                                                        <AribaCoverageBarChart data={spendCoverageData}/>
                                                    </>
                                                    : <NoData />
                                                }
                                                </div>
                                            </Card>
                                            </div>
                                        </Col> */}
                                       
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <div ref={annualizedEstESourcingSpendSplitChartRef} style={{height: '100%'}}>
                                                <Card style={{ height: '100%' }} className="archlet-chart-card">
                                                    <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                        {!pieChartToggle ? 'Project Count Split' : 'Event Count Split'}
                                                        <span style={{float: 'right'}}>
                                                            <DropdownWithIcons checkPDFDownloaded={checkPDFDownloaded} modalRef={annualizedEstESourcingSpendSplitChartRef} kpiName={!pieChartToggle ? 'Project Count Split' : 'Event Count Split'}/>
                                                        </span>
                                                    </div>
                                                    <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                                                        <div>
                                                            <SingleSelectDropdown className='buy-con-dropdown-modal' 
                                                                                    childList={pieChartBreakdownValue} 
                                                                                    // label="View Spend Breakdown By" 
                                                                                    label={!pieChartToggle ? 'View Project Count Breakdown By' : 'View Event Count Breakdown By'} 
                                                                                    selectedValue={spendBreakdownVal} 
                                                                                    setSelectedValue={onDropdownChange} 
                                                            />
                                                        </div>
                                                        
                                                        <div style={{display: 'flex'}}>
                                                            <span 
                                                                style={{position: 'relative', top: '1.1rem', color: '#616161',fontWeight:!pieChartToggle?"700":"400",marginRight: '0.3rem'}}
                                                                className='ph-spend-toggle-text'
                                                                >Project</span>
                                                            <Toggle 
                                                                    onUpdate={() => {
                                                                        setPieChartToggle(!pieChartToggle)
                                                                    }
                                                                    }
                                                                    size="small"
                                                                    value=""
                                                                    variant="horizontal"
                                                            />
                                                            <span className='ph-spend-toggle-text' style={{position: 'relative', top: '1.1rem', left: '0.3rem', color: '#616161',fontWeight:pieChartToggle?"700":"400"}}>Event</span>
                                                        </div>
                                                    </div>
                                                    {
                                                        pieChartData && pieChartData?.length > 0 ?
                                                            <>
                                                                <AribaPieChart data={pieChartData} colorArray={pieChartColors}/>
                                                                <LegendList legends={pieChartLegends} />
                                                            </>      
                                                        : <NoData />
                                                    }
                                                </Card>
                                            </div>
                                        </Col>    

                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <div ref={spendByEventTypevsProjectsChartRef} style={{height: '100%'}}>
                                                <Card style={{ height: '100%' }} className="archlet-chart-card">
                                                
                                                    <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                    
                                                        {/* Annualized Est. E-Sourcing Spend (MN USD) by Event Type vs Projects */}
                                                        Project (Event Type) Monthly Trend
                                                        <span style={{float: 'right'}}>
                                                            <DropdownWithIcons checkPDFDownloaded={checkPDFDownloaded} modalRef={spendByEventTypevsProjectsChartRef} kpiName={'Project (Event Type) Monthly Trend'}/>
                                                        </span>
                                                        {/* Arriba E-sourcing Spend Coverage */}
                                                        {/* <InfoIcon  style={{position: 'relative', left: '0.5rem'}}
                                                                text={`For Corrugates (PBNA): SGA Cost = Overhead; R&D = Indirect
                                                                For Cans: Value Add Discrete + Process = Value Add Discrete
                                                                For Preform and Bottle: Preassembly by Internal = Value Add Discrete`} /> */}
                                                    </div>
                                                    {/* <div> */}
                                                    {
                                                        spendAndProjectCountByMonthAndEventTypeData && spendAndProjectCountByMonthAndEventTypeData?.length>0 ?
                                                        <>
                                                            {/* <AribaLineThreeColoredBarChart linebarchartData={mockLineThreeColoredBarChart}/> */}
                                                            <AribaLineThreeColoredBarChart linebarchartData={spendAndProjectCountByMonthAndEventTypeData}/>
                                                            <LegendList legends={lineThreeColoredBarChartLegends} />
                                                        </>
                                                        : <NoData />
                                                    }
                                                    {/* </div> */}
                                                </Card>
                                            </div>
                                        </Col>
                                    </Row>
                                    <br />
                                    <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <div ref={SpendbySectorandCategoryL1ChartRef}>
                                                <Card style={{ height: '100%' }}>
                                                    {
                                                        projectCountAtSectorAndCategoryL1Data && projectCountAtSectorAndCategoryL1Data?.length>0 ?
                                                            <>
                                                            
                                                                <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left", display: "flex", justifyContent:"space-between" }}>
                                                                        {/* <span>{stackedBarChartToggle?"Annualized Est. E-Sourcing Count by Sector and Category L1​":"Annualized Est. E-Sourcing Spend (MN USD) by Sector and Category L1​"}</span> */}
                                                                        <span>Project Count by Sector and Category L1</span>

                                                                        <div style={{display: 'flex'}}>
                                                                            <span style={{float: 'right'}}>
                                                                                <DropdownWithIcons checkPDFDownloaded={checkPDFDownloaded} modalRef={SpendbySectorandCategoryL1ChartRef} kpiName={"Project Count by Sector and Category L1"}/>
                                                                            </span>
                                                                            {/* <span className='ph-spend-toggle-text' style={{fontWeight:!stackedBarChartToggle?"700":"400"}}>Spend</span>
                                                                            <Toggle 
                                                                                    onUpdate={function Ma(e) {
                                                                                        setStackedBarChartToggle(e);
                                                                                    }}
                                                                                    size="small"
                                                                                    value=""
                                                                                    variant="horizontal"
                                                                            />
                                                                            <span className='ph-spend-toggle-text' style={{fontWeight:stackedBarChartToggle?"700":"400"}}> &nbsp;&nbsp;Count</span> */}
                                                                        </div>
                                                                </div>
                                                                
                                                                <SpendStackedBarChart categories={l1CatgoryColorsData} data={projectCountAtSectorAndCategoryL1Data} isVeridionChart={true}/>
                                                                <LegendList legends={categoryColorMapping} />
                                                        </> 
                                                        :
                                                            <NoData />
                                                    }
                                                </Card>
                                            </div>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>

                                        
                                        
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <div ref={spendBySectorEvenTypeStatusChartRef}>
                                                <Card style={{ height: '100%' }} className="archlet-chart-card">
                                                    <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                        {/* Annualized Est. E-Sourcing Spend (MN USD) by Sector, Event Type and Status */}
                                                        Project Count by Sector, Event Type and Status
                                                        <span style={{float: 'right'}}>
                                                            <DropdownWithIcons checkPDFDownloaded={checkPDFDownloaded} modalRef={spendBySectorEvenTypeStatusChartRef} kpiName={"Project Count by Sector, Event Type and Status"}/>
                                                        </span>
                                                    </div>
                                                
                                                    {
                                                        aggregatedSpendBySectorEventData && Object.keys(aggregatedSpendBySectorEventData)?.length > 0 ?
                                                            <>
                                                        
                                                            {/* <AribaLineThreeColoredBarChart linebarchartData={mockLineThreeColoredBarChart}/>
                                                            <LegendList legends={lineThreeColoredBarChartLegends} /> */}
                                                                <AribaThreeColoredBarChart data={convertedAggregatedSpendBySectorEventData}/>
                                                                <LegendList legends={threeColoredBarChartLegends} />
                                                            </>      
                                                        : <NoData />
                                                    }
                                                </Card>
                                            </div>
                                        </Col>    
                                    </Row>
                                    <br />
                                    
                                    <br />
                                    {/* <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <div ref={annualizedSpendRangesChartRef}>
                                                <Card style={{ height: '100%' }}>
                                                    {
                                                        spendBucketAndProjectCountData && spendBucketAndProjectCountData?.length>0 ?
                                                            <>
                                                            
                                                                <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                                    Number of Projects as per Annualized Est. E-Sourcing Spend Ranges
                                                                    <span style={{float: 'right'}}>
                                                                        <DropdownWithIcons checkPDFDownloaded={checkPDFDownloaded} modalRef={annualizedSpendRangesChartRef} kpiName={"Number of Projects as per Annualized Est. E-Sourcing Spend Ranges"}/>
                                                                    </span>
                                                                </div>
                                                                <AribaBucketTreemapChart 
                                                                    data={spendBucketAndProjectCountData}                                                             
                                                                />
                                                                <LegendList legends={treeMapLegends} />
                                                        </> 
                                                        :
                                                            <NoData />
                                                    } 
                                                </Card>
                                            </div>
                                        </Col>
                                    </Row> */}

                                    <br />
                                    <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            
                                            {
                                                tableData && tableData?.length > 0 ?
                                                    <div className="ph-table-wrapper">
                                                        <CommonTable className="ariba-table" data={tableData} columns={aribaColumns} tableHeader="Project Details" enableSorting={true} columnsToInclude={aribaColumnsToInclude} columnMapping={aribaColumnMapping} tableName={'PROJECT DETAILS'}/>
                                                    </div>
                                                    : <Card style={{ height: '100%' }}><NoData /></Card>
                                            }
                                        </Col>
                                    </Row>
                                    <br />

                                    <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                                        {
                                            aribaData?.owners?.length > 0 &&
                                            <div style={{width: '100%'}}>Please reach out to {aribaData?.owners?.map((contact, index) => (
                                                <React.Fragment key={index}>
                                                    <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                                    {index < aribaData?.owners?.length - 1 && ', '}
                                                </React.Fragment>
                                            ))} for any query on the data displayed.</div>
                                        }
                                        <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                                    </div>
                                </div>
                        
                        </>
                }    
                <br/>  
            </div>  
        </Modal>
        )
}

export default AribaModal